import { map } from 'lodash'
import React, { useContext, useMemo } from 'react'
import styled from 'styled-components'

import GlobalUserContext from '../../contexts/GlobalUserContext'
import Select from '../Select'

const Wrapper = styled.div`
  min-width: 180px;
`
type TGlobalUser = {
  useDarkMode?: boolean
}
const GlobalUserSelect = (props: TGlobalUser): React.ReactElement => {
  const { value, userOptions, onChange } = useContext(GlobalUserContext)

  const options = useMemo(() => {
    return map(userOptions, (opt) => ({
      value: opt.value.settingId,
      label: opt.label,
    }))
  }, [])

  return (
    <Wrapper>
      <Select options={options} value={value} onChange={onChange} direct />
    </Wrapper>
  )
}

export default GlobalUserSelect
